import { useMutation, useQuery, useApolloClient } from '@apollo/client';
import React, { useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Accordion from 'react-bootstrap/Accordion';
import { useTheme } from 'styled-components';

import { LIST_MY_BOOKS } from '../queries';
import { DELETE_BOOK } from '../mutations';
import Button from '../../../components/Button';

import ErrorModal from '../../../components/ErrorModal';
import FullScreenLoader from '../../../components/FullScreenLoader';
import BookListItem from '../../../components/BookListItem';
import { FormattedMessage } from 'react-intl';
import Box from '../../../components/layout/Box';
import Icon from '../../../components/Icon';

const ProfileBooks = () => {
  const [showModal, setShowModal] = useState();
  const [error, setError] = useState();

  const client = useApolloClient();
  const navigate = useNavigate();

  const theme = useTheme();

  const [bookToDelete, setBookToDelete] = useState();

  const [deleteBook] = useMutation(DELETE_BOOK);

  const { data, loading } = useQuery(LIST_MY_BOOKS, {
    variables: {
      myAds: true,
      pagination: {
        limit: 100,
        offset: 0,
      },
    },
    onError: () => {
      setError(true);
    },
  });

  const goToNewBook = useCallback(() => {
    navigate('/new?mode=search');
  }, []);

  const handleShow = () => setShowModal(true);

  const handleClose = () => {
    setBookToDelete();
    setShowModal(false);
  };

  const handleDeletePress = (book) => {
    setBookToDelete(book);
    handleShow();
  };

  const handleDelete = () => {
    if (bookToDelete) {
      deleteBook({
        variables: {
          id: bookToDelete.id,
        },
        onCompleted: () => {
          client.cache.evict({ fieldName: 'listBooks' });
          handleClose();
        },
      });
    }
  };

  const books = data?.listBooks || [];

  if (loading) {
    return <FullScreenLoader />;
  }

  return (
    <>
      <Box className="flex-column">
        <Accordion flush>
          {books?.length ? (
            books.map((book) => {
              return (
                <Accordion.Item
                  className="noselect mb-2"
                  eventKey={book.id.toString()}
                  key={book.id.toString()}
                  style={{ padding: 0, backgroundColor: 'transparent' }}
                >
                  <Box
                    className="mb-3 pb-3 flex-column"
                    style={{
                      borderBottom: '2px solid #e7e7e7',
                    }}
                  >
                    <Accordion.Header
                      className="noselect"
                      style={{
                        display: 'flex',
                        padding: 0,
                        flexShrink: 1,
                        flexGrow: 1,
                        border: 0,
                      }}
                    >
                      <BookListItem
                        disabled
                        book={book}
                        onClick={undefined}
                        showBorder={false}
                        after={<Box style={{ display: 'none' }}></Box>}
                      />
                    </Accordion.Header>

                    <Accordion.Body className="noselect">
                      <div className="d-flex">
                        <Link
                          style={{
                            marginRight: 20,
                            color: theme.colors.fontBaseColor,
                            border: '2px solid #e7e7e7',
                            borderRadius: 4,
                          }}
                          className="px-2 py-1"
                          to={`/book?i=${book.id}`}
                        >
                          <Box className="align-items-center">
                            <Box style={{ marginRight: 4 }}>
                              <Icon
                                name="eye-outline"
                                size={24}
                                color={theme.colors.fontBaseColor}
                              />
                            </Box>

                            <FormattedMessage defaultMessage="Visa" />
                          </Box>
                        </Link>

                        <Link
                          style={{
                            marginRight: 20,
                            color: theme.colors.primaryColor,
                            border: '2px solid #e7e7e7',
                            borderRadius: 4,
                          }}
                          className="px-2 py-1"
                          to={`/edit?i=${book.id}`}
                        >
                          <Box className="align-items-center">
                            <Box style={{ marginRight: 4 }}>
                              <Icon
                                name="edit-outline"
                                size={24}
                                color={theme.colors.primaryColor}
                              />
                            </Box>

                            <FormattedMessage defaultMessage="Ändra" />
                          </Box>
                        </Link>

                        <Box
                          style={{
                            color: 'red',
                            cursor: 'pointer',
                            border: '2px solid #e7e7e7',
                            borderRadius: 4,
                          }}
                          className="px-2 py-1"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleDeletePress(book);
                          }}
                        >
                          <Box className="align-items-center">
                            <Box style={{ marginRight: 4 }}>
                              <Icon
                                name="trash-outline"
                                size={18}
                                color={theme.colors.errorColor}
                              />
                            </Box>

                            <FormattedMessage defaultMessage="Ta bort" />
                          </Box>
                        </Box>
                      </div>
                    </Accordion.Body>
                  </Box>
                </Accordion.Item>
              );
            })
          ) : (
            <div
              className="py-5 px-2"
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                border: '2px solid #e7e7e7',
                borderRadius: 10,
              }}
            >
              <h3>Du har inga annonser</h3>
              <div
                style={{
                  textAlign: 'center',
                }}
              >
                Tryck på knappen nedan för att lägga upp en ny annons
              </div>
              <Button onClick={goToNewBook} style={{ marginTop: 15 }}>
                Ny annons
              </Button>
            </div>
          )}
        </Accordion>
      </Box>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Ta bort annons</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Är du säker på att du vill ta bort den här annonsen?
        </Modal.Body>
        <Modal.Footer>
          <Button backgroundColor="errorColor" onClick={handleDelete}>
            Ta bort
          </Button>
          <Button backgroundColor="primaryColor" onClick={handleClose}>
            Avbryt
          </Button>
        </Modal.Footer>
      </Modal>

      <ErrorModal error={error} />
    </>
  );
};

export default ProfileBooks;
